import { connect } from "react-redux";
import { setStreamItemHide } from "../../../actions/streamItem";
import StreamItemHide from "../StreamItemHide";

function select({ streamItems: { byId }, user }, { streamItemId }) {
  const { hidden, hiddenByAgent } = byId[streamItemId] || {};
  const type = hidden ? "unhide" : "hide";

  const disabled = !!hiddenByAgent && !user.isAgent;

  return {
    hidden: !!hidden,
    type,
    disabled
  };
}

const actions = {
  setStreamItemHide
};

export default connect(select, actions)(StreamItemHide);
